import { render } from "./VolumeCell.vue?vue&type=template&id=108261d4&scoped=true"
import script from "./VolumeCell.vue?vue&type=script&lang=js"
export * from "./VolumeCell.vue?vue&type=script&lang=js"

import "./VolumeCell.vue?vue&type=style&index=0&id=108261d4&scoped=true&lang=scss"

import exportComponent from "/var/www/eztrade-client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-108261d4"]])

export default __exports__